module.exports = __webpack_public_path__ + "img/how-it-work-03.0e382e19.png";